import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Servidor from "../config/Servidor";
import { FaEye } from "react-icons/fa";
import "./ListaUsuarios.css";

export default function ListaUsuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [menuRol, setMenuRol] = useState(false);
  const [filtroRol, setFiltroRol] = useState("todos");

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${Servidor.IP}/usuarios`)
      .then((res) => {
        if (res.data.ok) {
          setUsuarios(res.data.usuarios);
        }
      })
      .catch(() => alert("Error al cargar usuarios"));
  }, []);

  const roles = {
    1: "Administrador",
    2: "Supervisor",
    3: "Cobrador",
    4: "Independiente",
  };

  // =========================================
  // FECHA SOLO YYYY-MM-DD
  // =========================================

  const formatearFechaBolivia = (fecha) => {
    if (!fecha) return "-";

    const date = new Date(fecha);

    if (isNaN(date.getTime())) return "-";

    const opciones = {
      timeZone: "America/La_Paz",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };

    const partes = new Intl.DateTimeFormat(
      "sv-SE",
      opciones
    ).formatToParts(date);

    const year = partes.find(
      (p) => p.type === "year"
    )?.value;

    const month = partes.find(
      (p) => p.type === "month"
    )?.value;

    const day = partes.find(
      (p) => p.type === "day"
    )?.value;

    return `${year}-${month}-${day}`;
  };

  // =========================================
  // COLOR FLUTTER
  // =========================================

  const flutterToWebColor = (flutterColor) => {
    if (!flutterColor || flutterColor.length !== 9) {
      return flutterColor;
    }

    const r = flutterColor.substring(3, 5);
    const g = flutterColor.substring(5, 7);
    const b = flutterColor.substring(7, 9);

    return `#${r}${g}${b}`;
  };

  // =========================================
  // CALCULAR DIAS
  // =========================================

  const calcularDias = (fechaVencimiento) => {
    if (!fechaVencimiento) return null;

    const hoy = new Date();
    const vence = new Date(fechaVencimiento);

    hoy.setHours(0, 0, 0, 0);
    vence.setHours(0, 0, 0, 0);

    const diferencia = vence - hoy;

    return Math.ceil(
      diferencia / (1000 * 60 * 60 * 24)
    );
  };

 // =========================================
// FILTRADO
// =========================================

const filtrados = usuarios.filter((u) => {
  const texto = busqueda.toLowerCase().trim();

  const nombreCompleto = `
    ${u.persona_nombre || ""}
    ${u.primerapellido || ""}
    ${u.segundoapellido || ""}
  `.toLowerCase();

  const coincideBusqueda =
    u.usuario?.toLowerCase().includes(texto) ||
    u.id_usuario?.toString().includes(texto) ||
    u.persona_nombre?.toLowerCase().includes(texto) ||
    u.primerapellido?.toLowerCase().includes(texto) ||
    u.segundoapellido?.toLowerCase().includes(texto) ||
    nombreCompleto.includes(texto);

  if (!coincideBusqueda) {
    return false;
  }

  if (filtroRol === "supervisores") {
    return u.id_rol === 2;
  }

  if (filtroRol === "cobradores") {
    return u.id_rol === 3;
  }

  if (filtroRol === "independientes") {
    return u.id_rol === 4;
  }

  return true;
});


  // =========================================
  // CAMBIAR FILTRO
  // =========================================

  const cambiarFiltro = (filtro) => {
    setFiltroRol(filtro);
    setMenuRol(false);
  };

  // =========================================
  // ABRIR USUARIO
  // =========================================

  const abrirUsuario = (id) => {
    navigate(`/VerUsuario/${id}`);
  };

  return (
    /*
      translate="no" evita que Google Translate
      traduzca el contenido de esta página.
    */
    <div
      className="usuarios-container notranslate"
      translate="no"
    >

      {/* =========================================
          ENCABEZADO
      ========================================= */}

      <div className="usuarios-header">

        {/* VOLVER */}

        <button
          className="volver-header"
          onClick={() => navigate("/ingresoadmin")}
        >
          <span className="flecha-volver">↩</span>
          <span>Volver</span>
        </button>


        {/* TITULO */}

        <h1 className="usuarios-title">
          Lista de Usuarios
        </h1>


        {/* TRES PUNTOS */}

        <div className="menu-rol-container">

          <button
            className="btn-tres-puntos"
            onClick={() => setMenuRol(!menuRol)}
          >
            ⋮
          </button>

          {menuRol && (
            <div className="menu-rol">

              <button
                className={
                  filtroRol === "todos"
                    ? "activo"
                    : ""
                }
                onClick={() =>
                  cambiarFiltro("todos")
                }
              >
                👥 Ver todos
              </button>

              <button
                className={
                  filtroRol === "supervisores"
                    ? "activo"
                    : ""
                }
                onClick={() =>
                  cambiarFiltro("supervisores")
                }
              >
                👤 Ver supervisores
              </button>

              <button
                className={
                  filtroRol === "cobradores"
                    ? "activo"
                    : ""
                }
                onClick={() =>
                  cambiarFiltro("cobradores")
                }
              >
                💰 Ver cobradores
              </button>

              <button
                className={
                  filtroRol === "independientes"
                    ? "activo"
                    : ""
                }
                onClick={() =>
                  cambiarFiltro("independientes")
                }
              >
                👨‍💼 Ver independientes
              </button>

            </div>
          )}

        </div>

      </div>


      {/* =========================================
          FILTRO ACTUAL
      ========================================= */}

      {filtroRol !== "todos" && (
        <div className="filtro-actual">
          Mostrando:{" "}
          <strong>
            {filtroRol === "supervisores"
              ? "Supervisores"
              : filtroRol === "cobradores"
              ? "Cobradores"
              : "Independientes"}
          </strong>
        </div>
      )}


      {/* =========================================
          BUSCADOR
      ========================================= */}

    <input
  type="text"
  className="input-buscador"
  placeholder="Buscar por ID, usuario, nombre o apellido..."
  value={busqueda}
  onChange={(e) =>
    setBusqueda(e.target.value)
  }
/>



      {/* =========================================
          TABLA
      ========================================= */}

      <div className="tabla-container">

        <div className="tabla-scroll">

      <table className="tabla">

  <thead>
    <tr>

      <th>ID</th>

  <th>Usuario</th>

      <th>Nombre Usuario</th>


      <th>Cédula</th>

      <th>ID Persona</th>

      <th>Fecha</th>

      <th>Vence</th>

      <th>Meses pagos</th>

      <th>Tiempo</th>

      <th>Activo</th>

      <th>Rol</th>

      <th>Supervisor</th>

      <th>Nombre Supervisor</th>

      <th>Tema</th>

      <th className="columna-ver">
        Ver
      </th>

    </tr>
  </thead>


  <tbody>

    {filtrados.map((u) => {

      const dias =
        calcularDias(
          u.fecha_vencimiento
        );

      return (

        <tr
          key={u.id_usuario}

          /*
            TODA LA FILA ABRE EL USUARIO
          */

          onClick={() =>
            abrirUsuario(u.id_usuario)
          }

          className="fila-usuario"
        >

          {/* ID USUARIO */}

          <td>
            {u.id_usuario}
          </td>
  <td>
                      <strong>{u.usuario}</strong>
                    </td>


          {/* NOMBRE */}


          {/* APELLIDO */}

          <td>
                   {u.persona_nombre || "-"} {" "}
            {u.primerapellido || ""}{" "}
            {u.segundoapellido || ""}
          </td>


          {/* CÉDULA */}

          <td>
            {u.cedula || "-"}
          </td>


          {/* ID PERSONA */}

          <td>
            {u.id_persona || "-"}
          </td>


          {/* FECHA */}

          <td>
            {formatearFechaBolivia(
              u.fecha
            )}
          </td>


          {/* VENCIMIENTO */}

          <td>
            {formatearFechaBolivia(
              u.fecha_vencimiento
            )}
          </td>


          {/* MESES PAGADOS */}

          <td>
            {u.meses_pagados ?? "-"}
          </td>


          {/* TIEMPO */}

          <td
            className={
              dias < 0
                ? "dias-rojo"
                : dias <= 5
                ? "dias-naranja"
                : "dias-verde"
            }
          >
            {dias ?? "-"}
          </td>


          {/* ACTIVO */}

          <td>
            {u.activo
              ? "✔"
              : "✘"}
          </td>


          {/* ROL */}

          <td>

            <span
              className={`rol rol-${u.id_rol}`}
            >
              {roles[u.id_rol] ||
                "Sin rol"}
            </span>

          </td>


          {/* ID SUPERVISOR */}

          <td>
            {u.id_supervisor || "-"}
          </td>


          {/* NOMBRE SUPERVISOR */}

          <td>
            {u.nombre_supervisor?.trim() || "-"}
          </td>


          {/* TEMA */}

          <td>

            <div
              className="tema-circulo"

              style={{
                background:
                  `conic-gradient(
                    ${flutterToWebColor(u.color1) || "#ccc"} 0deg 90deg,
                    ${flutterToWebColor(u.color2) || "#eee"} 90deg 180deg,
                    ${flutterToWebColor(u.color3) || "#ddd"} 180deg 270deg,
                    ${flutterToWebColor(u.color4) || "#bbb"} 270deg 360deg
                  )`,
              }}
            />

          </td>


          {/* OJO AL FINAL */}

          <td className="columna-ver">

            <button
              className="btn-ver"

              onClick={(e) => {

                /*
                  Evita que el click
                  se ejecute dos veces.
                */

                e.stopPropagation();

                abrirUsuario(
                  u.id_usuario
                );

              }}
            >

              <FaEye />

            </button>

          </td>

        </tr>

      );

    })}

  </tbody>

</table>


        </div>

      </div>


      {filtrados.length === 0 && (
        <p className="sin-resultados">   
          No se encontraron usuarios.
        </p>
      )}

    </div>
  );
}
